import api from './api';

export const chimneyService = {
  /**
   * Jedna strona listy (paginated). Zwraca { results, count, next, previous }.
   * @param {number} [page=1]
   * @param {{ city?: string }} [filters]
   */
  getPage: async (page = 1, filters = {}) => {
    const params = { page };
    const city = (filters.city || '').trim();
    if (city) params.city = city;
    const response = await api.get('/chimneys/', { params });
    return response.data;
  },

  /**
   * Pobiera wszystkie strony i zwraca płaską tablicę kominiarzy (dla mapy / admina).
   */
  getAllPages: async (filters = {}) => {
    let all = [];
    let page = 1;
    while (true) {
      const data = await chimneyService.getPage(page, filters);
      all = all.concat(data.results || []);
      if (!data.next) break;
      page += 1;
    }
    return all;
  },

  /** @deprecated Użyj getPage(1) lub getAllPages(). Zostawione dla zgodności – zwraca pierwszą stronę. */
  getAll: async () => {
    return chimneyService.getPage(1);
  },

  getById: async (id) => {
    const response = await api.get(`/chimneys/${id}/`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.patch(`/chimneys/${id}/`, data);
    return response.data;
  },

  getMyChimney: async () => {
    const response = await api.get('/chimneys/me/');
    return response.data;
  },
};
